import React from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { useScreenInfo } from 'src/hooks/common';
import { SxProp } from 'src/types/mui';

interface DetailPageLayoutProps {
  titleContent: React.ReactNode;
  topRightContent?: React.ReactNode;
}

export const DetailPageLayout: React.FC<React.PropsWithChildren<DetailPageLayoutProps>> = ({
  titleContent,
  topRightContent,
  children,
}) => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <Box sx={childrenContainerStyles}>{children}</Box>;
  }

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" alignItems="center" px={4} gap={2}>
        <Typography py={2}>{titleContent}</Typography>
        <Box>{topRightContent}</Box>
      </Box>
      <Divider />

      <Box sx={childrenContainerStyles}>{children}</Box>
    </React.Fragment>
  );
};

const childrenContainerStyles: SxProp = theme => ({
  paddingY: 3,
  paddingX: 4,

  [theme.breakpoints.down('sm')]: {
    paddingY: 0,
    paddingX: 0,
  },
});
